import React from "react";
import PropTypes from "prop-types";
import MetierCard from "./MetierCard";
import Reveal from "ui/Reveal";

import {
  MetiersBlockWrapper,
  Title,
  MetiersGrid,
} from "./styles/MetiersBlockStyles";

const MetiersBlock = ({ metiersData }) => {
  const { titreRubrique, metier } = metiersData;
  return (
    <React.Fragment>
      <MetiersBlockWrapper className="metiers-block">
        <div className="fixed-container">
          <Reveal>
            <Title className="withline">{titreRubrique}</Title>
          </Reveal>
          <MetiersGrid>
            {metier &&
              metier.map((item, i) => (
                <Reveal stretch key={i} delay={(i % 4) * 110}>
                  <MetierCard data={item.metier} />
                </Reveal>
              ))}
          </MetiersGrid>
        </div>
      </MetiersBlockWrapper>
    </React.Fragment>
  );
};

MetiersBlock.propTypes = {};

MetiersBlock.defaultProps = {};

export default MetiersBlock;
